import { get } from 'lodash';
import CustomerType from '../const/customer_type';
import {isUserMedical, isAdult} from "./userSelectors";
import {isStrictMedicalInventoryRestrictionEnabled} from "./configSelectors";

export const getCurrentCustomerType = (state) => {
  const defaultPatientType = getDefaultPatientType(state);

  return get(state, 'user.customerType') // profile
            || get(state, 'customerType.currentCustomerType') // guests, not logged in
            || defaultPatientType; // default dispensary config
};

const getDefaultPatientType = (state) => {
  const defaultPatientTypeValue = get(state, 'config.DEFAULT_PATIENT_TYPE');

  if (!defaultPatientTypeValue) {
    return undefined;
  }

  return defaultPatientTypeValue === 'medical' ? CustomerType.MEDICAL : CustomerType.ADULT;
};

export const getSelectedCustomerType = (state) => {
  const defaultPatientType = getDefaultPatientType(state);

  return get(state, 'customerType.currentCustomerType') || defaultPatientType;
};

export const isStrictMedicalCustomerType = (state) => {
  return (
    isStrictMedicalInventoryRestrictionEnabled(state)
    && state.user
    && isUserMedical(state)
    && !isAdult(state)
  );
};



// WEBPACK FOOTER //
// ./src/selectors/customer_type_selector.js